import { useEffect, useState } from "react";
import { EncabezadoPDTO } from "../../interfaces/ProcedimientosInterface";
import { API_PROCEDIMIENTOS } from "../../features/constants";
import { Procedimiento } from "./procedimientos";

export const ListaProcedimientos = ()=>{

    const [procedimientos, setProcedimientos] = useState<EncabezadoPDTO[]>([]);

    const [procedimientoSelect, setProcedimientoSelect] = useState<EncabezadoPDTO|undefined>(undefined)

    const [mostrarProcedimiento, setMostrarProcedimiento] = useState(false);

    let init = {
            method: "POST",
            body: JSON.stringify({
            }),
            header:{
                "Content-Type":"aplication/json"
            }
        };
    useEffect(()=>{
        fetch(API_PROCEDIMIENTOS + "/Listar-Procedimientos",init)
            .then(response=>response.json())
            .catch(error=>console.log(error))
            .then((data:EncabezadoPDTO[])=>{
                setProcedimientos(data);
            })
    },[])

    return(
        <>
        <div
            className="row justify-content-center align-items-start g-2"
        >
            <div className={mostrarProcedimiento?"col-2":"col"}>
                <div
                    className="table-responsive"
                >
                    <table
                        className="table table-striped table-hover table-borderless table-dark align-top"
                    >
                        <thead className="table-dark">
                            <tr>
                                <th 
                                    onClick={()=>(setProcedimientoSelect(undefined),setMostrarProcedimiento(false))}
                                >{mostrarProcedimiento?<i className="bi bi-arrow-return-left"></i>:""} Código</th>
                                {!mostrarProcedimiento?<th>Versión</th>:<div></div>}
                                {!mostrarProcedimiento?<th>Título</th>:<div></div>}
                                {!mostrarProcedimiento?<th>Área</th>:<div></div>}
                                {!mostrarProcedimiento?<th>Fecha de Vigencia</th>:<div></div>}
                            </tr>
                        </thead>
                        <tbody className="table-group-divider">
                            {
                                procedimientos.map((proced,key)=>(
                                    <tr
                                        key={key}
                                        className={procedimientoSelect?.Id===proced.Id?"table-primary":"table-light"}
                                        onClick={()=>(setProcedimientoSelect(proced),setMostrarProcedimiento(true))}
                                    >
                                        <td>{proced.Codigo}</td>
                                        {!mostrarProcedimiento?<td>{proced.Version}</td>:<div></div>}
                                        {!mostrarProcedimiento?<td>{proced.Titulo}</td>:<div></div>}
                                        {!mostrarProcedimiento?<td>{proced.Area}</td>:<div></div>}
                                        {!mostrarProcedimiento?<td>{proced.Fecha_vigencia}</td>:<div></div>}
                                    </tr>
                                ))
                            }
                        </tbody>
                        <tfoot>
                            
                        </tfoot>
                    </table>
                </div>
            </div>
            <div className={mostrarProcedimiento?"col-10":"col-0"}>
                {
                    procedimientoSelect!==undefined?
                    <Procedimiento procedimiento={procedimientoSelect} />
                    :
                    <div></div>
                }
            </div>
        </div>
        
            
            
        </>
    )
}